import { useEffect } from "react";

function Home() {
  useEffect(() => {
    document.title = "GrowGrind – Accueil";
  }, []);

  return (
    <section className="container home-hero">
      <p className="hero-badge">Grow in Grace Grind in peace</p>
      
      <div className="video-section">
        <video className="hero-video" autoPlay loop muted playsInline>
          <source src="/gro.mp4" type="video/mp4" />
          Votre navigateur ne supporte pas la vidéo.
        </video>
      </div>
    </section>
  );
}

export default Home;
